import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Headers, Http, RequestOptions} from '@angular/http';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class ClientteamServiceService {
  readonly baseURL = DDP_ENV.userUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllClientContacts(clientId, page, status, size) {
    console.log('Inside get client contacts');
    return this._http.get(this.baseURL + '/clientcontact/client/' + clientId + '?page=' + page + '&status=' + status + '&size=' + size , this.buildHeaders());
  }
  addUpdateClientContact(clientContactForm, clientId) {
    return this._http.post(this.baseURL + '/client/' + clientId + '/clientcontact/add', clientContactForm, this.buildHeaders());
  }
  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }
}
